import { render, staticRenderFns } from "./ElementSetting.vue?vue&type=template&id=07c37806&"
import script from "./ElementSetting.vue?vue&type=script&lang=js&"
export * from "./ElementSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports